import { Account, Vendor } from "..";
import { INITIAL_ACCOUNT, INITIAL_VENDOR } from "../constants";

// sessionStorage, so the draft dies with the tab rather than lingering on a shared machine.
const DRAFT_KEY = "signUpDraft";

export interface SignUpDraft {
  account: Account;
  vendor: Vendor;
}

export const loadSignUpDraft = (): SignUpDraft => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(DRAFT_KEY) ?? "null");
    return {
      account: { ...INITIAL_ACCOUNT, ...saved?.account },
      vendor: { ...INITIAL_VENDOR, ...saved?.vendor },
    };
  } catch {
    return { account: INITIAL_ACCOUNT, vendor: INITIAL_VENDOR };
  }
};

export const saveSignUpDraft = ({ account, vendor }: SignUpDraft) => {
  try {
    // Files can't be serialised, and the password shouldn't sit in web storage.
    const draft: SignUpDraft = {
      account: { ...account, password: "", profilePhoto: null },
      vendor: {
        ...vendor,
        proofOfInsurance: null,
        businessLicense: null,
        electricalLicense: null,
      },
    };
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // Storage blocked or full: sign-up still works, it just won't survive a refresh.
  }
};

export const clearSignUpDraft = () => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch {}
};
